import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {PdfColorSettings} from "../models/pdf-color-settings.model";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PdfColorSettingsRepository {

  private readonly baseUrl: string;

  constructor(private httpClient: HttpClient) {
    this.baseUrl = environment.serviceUrl + '/mgmt';
  }

  getDefaults(): Observable<PdfColorSettings> {
    return this.httpClient.get<PdfColorSettings>(`${this.baseUrl}/partner/pdf-settings/defaults`);
  }

  getForPartner(partnerId: number): Observable<PdfColorSettings | null> {
    return this.httpClient.get<PdfColorSettings | null>(`${this.baseUrl}/partner/pdf-settings/${partnerId}`);
  }

  saveForPartner(partnerId: number, settings: PdfColorSettings): Observable<PdfColorSettings> {
    return this.httpClient.post<PdfColorSettings>(`${this.baseUrl}/partner/pdf-settings/${partnerId}`, settings);
  }
}
